module.exports = __webpack_public_path__ + "img/reward.afe6f7e7.svg";